import {cpfValidator, removeMask} from '../../../utils';
import {getNextPartnerQuestion} from '../flowPartners/flowPartners';

export const informPartnerCpf = (inputValue) => {
  const valueMessage = removeMask(inputValue);
  return cpfValidator(valueMessage);
};

export const setPartnerCpf = (
  ecState,
  partnerSel,
  partnerVd,
  partnerCpf,
  idQuestion,
  quizPartners,
  partnersTypeList
) => {
  let partners = ecState.partners.map((partner) => {
    if (partner.id === partnerSel.id) {
      return {
        ...partner,
        cpf: partnerVd.partnerCpf
      };
    }
    return partner;
  });

  let nextQuestion = getNextPartnerQuestion(
    idQuestion,
    quizPartners,
    partners,
    partnerSel,
    partnersTypeList
  );

  let messages = [
    {
      text: partnerCpf,
      type: 'response-sent'
    }
  ];

  messages.push(...nextQuestion.messages);

  return {
    messages,
    partners,
    partnerCpf,
    nextPartner: nextQuestion.partner,
    changePartner: nextQuestion.nextPartner,
    responseType: nextQuestion.responseTypeChange,
    partnersComplete: nextQuestion.partnersComplete,
    partnersTypeList: nextQuestion.partnersTypeList
  };
};
